/**
 * en-GB messages added by Phase 4 task S43 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s43EnGB = {
    // Starter group names (the customer can rename the groups afterwards).
    'group.template.visitors': 'Visitors',
    'group.template.staff': 'Staff',
    'group.template.contractors': 'Contractors',
    // Public API v1
    'error.api_group_not_allowed': 'This key is not allowed to use that group.',
    'error.member_host_unknown': 'The host does not exist.',
    // Data requests: the members provider
    'dp.hit.member': 'Member of {group}',
    'dp.section.members': 'Member record',
    'dp.section.member_fields': 'Member details',
    'dp.section.member_devices': 'Companion app devices',
    'dp.section.member_links': 'Links to other systems',
    'dp.keep.member_row': 'The member record stays, with no personal details, so past visits still count.',
};
//# sourceMappingURL=s43.js.map